import { UiInitialState } from "@/store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const initialState: UiInitialState = {
    parentScrollTop: 0,
    // Default to false until the embed script reports the actual orientation.
    isPortrait: false,
} 

const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        updateScrollTop: (state, action: PayloadAction<number>) => {
            state.parentScrollTop = action.payload;
        },
        updateOrientation: (state, action: PayloadAction<boolean>) => {
            state.isPortrait = action.payload;
        },

    }
});
export const { updateScrollTop, updateOrientation } = uiSlice.actions;

export default uiSlice;